<template>
  <div>
    <div id="aaa"></div>
    <van-nav-bar
      fixed
      title="订单列表"
      left-arrow
      @click-left="onClickLeft"
    />    
    <van-radio-group v-model="radio" v-if="orderList[0]">
      <van-cell-group>
        <van-cell 
          v-for="(item,index) in orderList" 
          :key="index" 
          :title="item.purchase_order_num"  
          clickable
          @click="selectedOrderNum(item.purchase_order_num)"
          >
          <!-- <template #label>
            <van-row>
              <van-col span="3">供应商</van-col>
              <van-col span="21">{{item.vendor_name}}</van-col>
            </van-row>
            <van-row 
            v-for="(ite,ind) in item.detail" 
            :key="ind"
            >
              <van-col span="14">{{ite.modelname}}</van-col>
              <van-col span="5">总数:{{ite.apply_num}}</van-col>
              <van-col span="5">待入:{{ite.remain_sign_num}}</van-col>
              
            </van-row>
          </template> -->
          <van-radio slot="right-icon" :name="item.purchase_order_num" />
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <van-empty v-else description="暂无订单" />
  </div>
</template>

<script>
import  { NavBar,  RadioGroup, Radio ,Field , Cell, Col, Row,CellGroup,Empty} from 'vant'
export default {
  components:{
    [NavBar.name]:NavBar,
    [RadioGroup.name]:RadioGroup,
    [Radio.name]:Radio,
    [Field.name]:Field,
    [Cell.name]:Cell,
    [Col.name]:Col,
    [Row.name]:Row,
    [Empty.name]:Empty,
    [CellGroup.name]:CellGroup
  },
  data(){
    return{
      radio: '',
      message:'',
      orderList:[]
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    selectedOrderNum(num) {
      this.radio = num;
      this.$router.push({
        name:"addsalesreturn",
        params:{
          ordernum:num,
          message:this.message,
        }
      });
    }
    
  },
  created() {
    this.orderList = this.$route.params.info;
    //window.console.log(this.orderList);
    this.radio = this.$route.params.ordernum;
    this.message = this.$route.params.message;
  }
}
</script>

<style scoped lang="less">
.van-nav-bar{
  background: #ffffff;color:#323233;font-weight: bold;
  /*background: #456;*/
  /*color:white;*/
}
.van-nav-bar__title{
  font-weight: 800;
  color:#323233;
}
#aaa{
  width:100vw;
  height:46px;
}
</style>